module.exports = __webpack_public_path__ + "img/fim-top.889191e3.png";